// Utility functions for handling default presets

export const loadDefaultPreset = (tableId) => {
  try {
    // Get default preset ID
    const defaultPresetId = localStorage.getItem(`default-preset-${tableId}`);
    if (!defaultPresetId) return null;

    // Get all presets
    const savedPresets = localStorage.getItem(`table-presets-${tableId}`);
    if (!savedPresets) return null;

    const presets = JSON.parse(savedPresets);
    const defaultPreset = presets.find(p => p.id === defaultPresetId);

    if (defaultPreset) {
      console.log('Loading default preset:', defaultPreset.name);
      return defaultPreset.config;
    }
  } catch (error) {
    console.warn('Failed to load default preset:', error);
  }
  
  return null;
};

export const hasDefaultPreset = (tableId) => {
  const defaultPresetId = localStorage.getItem(`default-preset-${tableId}`);
  return !!defaultPresetId;
};

// Filter preset utilities
export const loadDefaultFilterPreset = (tableId) => {
  try {
    // Get default filter preset ID
    const defaultPresetId = localStorage.getItem(`default-filter-preset-${tableId}`);
    if (!defaultPresetId) return null;

    // Get all filter presets
    const savedPresets = localStorage.getItem(`filter-presets-${tableId}`);
    if (!savedPresets) return null;

    const presets = JSON.parse(savedPresets);
    const defaultPreset = presets.find(p => p.id === defaultPresetId);

    if (defaultPreset) {
      console.log('Loading default filter preset:', defaultPreset.name);
      return defaultPreset.filters;
    }
  } catch (error) {
    console.warn('Failed to load default filter preset:', error);
  }
  
  return null;
};

export const hasDefaultFilterPreset = (tableId) => {
  const defaultPresetId = localStorage.getItem(`default-filter-preset-${tableId}`);
  return !!defaultPresetId;
};
